// Updated App.js - adding new routes
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import CategoriesPage from "./pages/CategoriesPage";
import DesignsPage from "./pages/DesignsPage";
import NewOrdersPage from "./pages/Orders/NewOrdersPage";
import OldOrdersPage from "./pages/Orders/OldOrdersPage";
import BrandsPage from "./pages/BrandsPage";
import HoldOrdersPage from "./pages/Orders/HoldOrdersPage";
import TypesPage from "./pages/TypesPage";
import SearchOrders from "./pages/SearchOrder";
import SearchDesignPage from "./pages/SearchDesignPage";
import ChangesOrdersPage from "./pages/Orders/ChangesOrdersPage";
import ReturnsPage from "./pages/ReturnsPage";
import SpamOrdersPage from "./pages/Orders/SpamOrdersPage"; // New
import ConfirmedOrdersPage from "./pages/Orders/ConfirmedOrdersPage"; // New
import GirabatcomOrdersPage from "./pages/Orders/GirabatcomOrdersPage";
import PrintingHoldOrdersPage from "./pages/Orders/PrintingHoldOrdersPage";
import IncompleteOrdersPage from "./pages/Orders/IncompleteOrdersPage";
import PrintedOrdersPage from "./pages/Orders/PrintedOrdersPage";
import CustomOrdersPage from "./pages/Orders/CustomOrdersPage";
import DepositRequiredOrdersPage from "./pages/Orders/DepositRequiredOrdersPage";
import UnderPurchaseOrdersPage from "./pages/Orders/Purchase/UnderPurchaseOrdersPage"; // New
import WaitingConfirmingOrdersPage from "./pages/Orders/Purchase/WaitingConfirmingOrdersPage"; // New
import ConfirmingOrdersPage from "./pages/Orders/Purchase/ConfirmingOrdersPage"; // New
import CanceledOrdersPage from "./pages/Orders/CanceledOrdersPage"; // New
import FollowUpPhonesPage from "./pages/Orders/FollowUpPhonesPage";
import BulkWhatsAppPage from "./pages/Orders/BulkWhatsAppPage";
import CancelledbyCustomerPage from "./pages/Orders/Purchase/CancelledbyCustomerPage";
import CouponsPage from "./pages/CouponsPage";
import ProductionDashboardPage from "./pages/Production/ProductionDashboardPage";
import AddToPrintQueuePage from "./pages/Production/AddToPrintQueuePage";
import AnalyticsDashboardPage from "./pages/Analytics/AnalyticsDashboardPage";
import UsersManagementPage from "./pages/UsersManagementPage";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/users" element={<UsersManagementPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/designs" element={<DesignsPage />} />
        <Route path="/categories/:categoryId/designs" element={<DesignsPage />} />
        <Route path="/brands" element={<BrandsPage />} />
        {/* Statues */}
        <Route path="/new-orders" element={<NewOrdersPage />} />
        <Route path="/old-orders" element={<OldOrdersPage />} />
        <Route path="/hold-orders" element={<HoldOrdersPage />} />
        <Route path="/changes-orders" element={<ChangesOrdersPage />} />
        <Route path="/spam-orders" element={<SpamOrdersPage />} /> 
        <Route path="/confirmed-orders" element={<ConfirmedOrdersPage />} /> 
        <Route path="/girabatcom-orders" element={<GirabatcomOrdersPage />} />
        <Route path="/printing-hold-orders" element={<PrintingHoldOrdersPage />} />
        <Route path="/incomplete-orders" element={<IncompleteOrdersPage />} />
        <Route path="/printed-orders" element={<PrintedOrdersPage />} />
        <Route path="/custom-orders" element={<CustomOrdersPage />} />
        <Route path="/deposit-required-orders" element={<DepositRequiredOrdersPage />} />
        <Route path="/canceled-orders" element={<CanceledOrdersPage />} />

        {/* Purchase */}
        <Route path="/under-purchase-orders" element={<UnderPurchaseOrdersPage />} /> 
        <Route path="/waiting-confirming-orders" element={<WaitingConfirmingOrdersPage />} /> 
        <Route path="/confirming-orders" element={<ConfirmingOrdersPage />} /> 
        <Route path="/follow-up-phones" element={<FollowUpPhonesPage />} />
        <Route path="/bulk-whatsapp" element={<BulkWhatsAppPage />} />
        <Route path="/cancelled-by-customer-orders" element={<CancelledbyCustomerPage />} />
         {/*Types  */}
        <Route path="/brands/:brandId/types" element={<TypesPage />} />
        <Route path="/search-orders" element={<SearchOrders />} />
        <Route path="/search-designs" element={<SearchDesignPage />} />
        <Route path="/returns" element={<ReturnsPage />} />
        <Route path="/coupons" element={<CouponsPage />} />
        <Route path="/production" element={<ProductionDashboardPage />} />
        <Route path="/production/add-orders" element={<AddToPrintQueuePage />} />
        <Route path="/analytics" element={<AnalyticsDashboardPage />} />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;